// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-slot__wrapper[data-v-c0eb15f6]{padding-bottom:24px;border-bottom:1px solid #d6d4d8}.article-slot__wrapper[data-v-c0eb15f6] .article-info__wrapper{padding-top:24px}", ""]);
// Exports
module.exports = exports;
